import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PillBadgeStatusEnum } from 'src/app/constants/badge-status.enum';
import { RequestStatuses } from 'src/app/constants/status.enum';
import { BasicRequestData } from 'src/app/models/api/simple-request-information-model';


@Component({
  selector: 'app-delete-user-request-list',
  templateUrl: './app-delete-user-request-list.component.html'
})
export class DeleteUserRequestListComponent {

  constructor(private translateService: TranslateService) {
  }

  private _request!: BasicRequestData;
  @Input() set request(request: BasicRequestData) {
    this._request = request;
    this.getStatusIndicator();
  }
  get request() {
    return this._request;
  }

  statusIndicator!: string;
  statusBadge!: string;

getStatusIndicator() {
    let primaryStatuses: string[] = RequestStatuses.PrimaryStatuses;
    let warningStatuses: string[] = RequestStatuses.WarningStatuses;
    let successStatuses: string[] = RequestStatuses.SuccessStatuses;
    let errorStatuses: string[] = RequestStatuses.ErrorStatuses;

    if (errorStatuses.includes(this.request.requestStatus)) {
      this.statusIndicator = PillBadgeStatusEnum.Danger;
    }
    if (successStatuses.includes(this.request.requestStatus)) {
      this.statusIndicator = PillBadgeStatusEnum.Success;
    }

    if (primaryStatuses.includes(this.request.requestStatus)) {
      this.statusIndicator = PillBadgeStatusEnum.Primary;
    } else if (warningStatuses.includes(this.request.requestStatus)) {
      this.statusIndicator = PillBadgeStatusEnum.Warning;
    } else if (successStatuses.includes(this.request.requestStatus)) {
      this.statusIndicator = PillBadgeStatusEnum.Success;
    } else if (errorStatuses.includes(this.request.requestStatus)) {
      this.statusIndicator = PillBadgeStatusEnum.Danger;
    } else {
      this.statusIndicator = PillBadgeStatusEnum.Warning;
    }

    if (this.statusIndicator === PillBadgeStatusEnum.Warning) {
      this.statusBadge = this.translateService.instant("Status.Sent");
    } else {
      this.statusBadge = this.translateService.instant("Status."+this.request.requestStatus);
    }
  }
}
